export const ONE_CHARACTER_LIMIT = 10000;
export const EMPTY_ARRAY = [];
